import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { scarcity } from '../data/offer';
type ScarcityBarProps = {
  tone?: 'light' | 'dark';
};
export function ScarcityBar({
  tone = 'light'
}: ScarcityBarProps) {
  const isDark = tone === 'dark';
  return <div className="w-full max-w-xl" data-id="element-56" data-mp="2q3hdmr91vecj">
      <div className="flex items-end justify-between gap-3" data-id="element-57" data-mp="2q2g4wtfib3xz">
        <p className={`flex items-center gap-1.5 text-sm font-bold ${isDark ? 'text-white' : 'text-ink'}`} data-id="element-58" data-mp="2b68idmgmlqfj">
          <FlameIcon className="h-4 w-4 shrink-0 text-alert" aria-hidden="true" data-id="element-59" data-mp="2g6399q0eig0l" />
          Only <span className="text-alert" data-id="element-60" data-mp="226lg6yg2oglf">{scarcity.spotsLeft} spots left</span> at the promo price
        </p>
        <span className={`shrink-0 font-display text-sm font-black ${isDark ? 'text-gold' : 'text-alert'}`} data-id="element-61" data-mp="274dau083qgtb">
          {scarcity.filledPercent}%
        </span>
      </div>
      <div className={`mt-2 h-4 w-full overflow-hidden rounded-full ${isDark ? 'bg-white/15' : 'bg-alert/10'}`} role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={scarcity.filledPercent} aria-label="Promotional spots claimed" data-id="element-62" data-mp="5drzkgg67wkw">
        <motion.div className="h-full rounded-full bg-alert" initial={{
        width: '60%'
      }} whileInView={{
        width: `${scarcity.filledPercent}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-63" data-mp="3dcesjx9rzj4a" />
      </div>
      <p className={`mt-1.5 text-xs ${isDark ? 'text-white/65' : 'text-ink/55'}`} data-id="element-64" data-mp="2gmfbfefk7ca3">
        When the remaining spots are claimed, the promotional price of $27 ends.
      </p>
    </div>;
}